import { createFileRoute, redirect, useRouter } from "@tanstack/react-router";
import { RouterProvider } from "react-aria-components";
import { AppShell } from "@/components/shell/AppShell";
import { RouteError } from "@/components/shell/RouteError";
import { startLive } from "@/lib/live";
import { applyLocale } from "@/lib/locale";
import { loadMe, useMe } from "@/lib/queries";

let localeAppliedFor: string | null = null;

export const Route = createFileRoute("/_app")({
  beforeLoad: async ({ context, location }) => {
    const me = await loadMe(context.queryClient);
    if (!me) throw redirect({ to: "/login", search: { redirect: location.href } });
    // The account language wins once per sign-in.
    if (localeAppliedFor !== me.id) {
      localeAppliedFor = me.id;
      applyLocale(me.locale);
    }
    startLive(context.queryClient);
    return { me };
  },
  component: AppLayout,
  errorComponent: RouteError,
});

function AppLayout() {
  const { me: initial } = Route.useRouteContext();
  const me = useMe().data ?? initial;
  const router = useRouter();
  return (
    <RouterProvider
      navigate={(to) => void router.navigate({ to: to as never })}
      useHref={(to) => router.buildLocation({ to: to as never }).href}
    >
      <AppShell me={me} />
    </RouterProvider>
  );
}
